import { FunctionComponent, useEffect, useMemo } from 'react'

import { ConfirmaTransferenciaFactory } from 'modules/pagamentos/factories/ConfirmaTransferencia'
import { SelecionarFavorecidoFactory } from 'modules/pagamentos/factories/SelecionarFavorecido'
import { useTransferencia } from 'modules/pagamentos/hooks/useTransferencia'

import TipoTransferencia from './components/TipoTranferencia'

const Transferir: FunctionComponent = () => {
  const { step, clear } = useTransferencia()

  useEffect(() => {
    clear()
  }, [])

  const componentSteps = useMemo(() => {
    return [
      {
        component: <TipoTransferencia />,
      },
      {
        component: <SelecionarFavorecidoFactory />,
      },
      {
        component: <ConfirmaTransferenciaFactory />,
      },
    ]
  }, [step])

  return componentSteps[step]?.component
}

export default Transferir
